export default "__VITE_ASSET__DOK5A8cL__"